import SMS from '../SMS';
import { IContact } from '@leedpulse-monorepo/interfaces';

export default class SMSWithContact {
  private _sms: SMS;
  private _contact: IContact;

  constructor(sms: SMS, contact: IContact) {
    this._sms = sms;
    this._contact = contact;
  }

  get sms(): SMS {
    return this._sms;
  }

  get contact(): IContact {
    return this._contact;
  }

  // Getters to display on the lists
  get id(): string {
    return this._sms.id;
  }
  get contactFullname(): string {
    return this._contact.contact.firstname + ' ' + this._contact.contact.lastname;
  }
  get contactFirstname(): string {
    return this._contact.contact.firstname;
  }
  get contactLastname(): string {
    return this._contact.contact.lastname;
  }
  get timestamp(): Date {
    return this._sms.created;
  }
  get messagePreview(): string {
    const body = this._sms.message;
    const msg = body?.length > 50 ? body?.slice(0, 50) + '...' : body;
    return msg;
  }
}
